import 'slick-carousel';
import { NgModule } from 'ng-metadata/core';
import { RotatorDirective } from './rotator.component';

@NgModule({
  imports: [
    /**
     * Slick Carousel
     * @see https://github.com/devmark/angular-slick-carousel
     */
    'slickCarousel',
  ],
  declarations: [
    RotatorDirective,
  ],
})
export class RotatorModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/rotator/rotator.module.ts